<template>
  <div class="my-5">
    <h6 class="mb-3" v-if="routeIsArborescenceGraph">Analytique</h6>
    <h5 class="mb-3" v-else>Analytique</h5>
    <b-row class="my-4">
      <b-col cols="6">Partisanerie</b-col>
      <b-col cols="6">
        {{ getPartisanship.positive }}/{{ getPartisanship.negative }}
      </b-col>
      <b-col cols="12" class="text-muted">
        Nombre d'interventions en faveur de l'idée principale vs le nombre
        d'interventions qui s'y opposent.
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col cols="6">Curiosité</b-col>
      <b-col cols="6">
        {{ getCuriosity.seen_comments }}/{{ getCuriosity.posted_comments }}
      </b-col>
      <b-col cols="12" class="text-muted">
        Le nombre d'interventions lues vs le nombre d'interventions publiées.
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col cols="6">Engagement</b-col>
      <b-col cols="6">{{ getCommitment }}</b-col>
      <b-col cols="12" class="text-muted">
        Réponses à ses notifications.
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col cols="6">Diversité de sources</b-col>
      <b-col cols="6">
        {{ getSourcesDiversity.references }}/{{ getSourcesDiversity.post }}
      </b-col>
      <b-col cols="12" class="text-muted">
        Le nombre de sources distinctes vs le nombre d'interventions publiées.
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col cols="6">Richesse</b-col>
      <b-col cols="6">
        {{ getSufficiency.discussions }}/{{ getSufficiency.responses }}
      </b-col>
      <b-col cols="12" class="text-muted">
        Le nombre de publications crées par l'étudiant vs le nombre de
        commentaires qu'il propose pour soutenir celles-ci.
      </b-col>
    </b-row>
    <b-row class="my-4">
      <b-col cols="6">Rigueur</b-col>
      <b-col cols="6">{{ getRigor }}</b-col>
      <b-col cols="12" class="text-muted">
        Le nombre de sources citées.
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @file       Student analytics component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { adminStudentMixin } from "@/modules/admin/components/students/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "studentProfileAnalytics",
  mixins: [adminStudentMixin],
  props: {
    deliberation: Number,
    groupId: Number
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    /**
     * Get partisanship.
     *
     * @return     {Object}  Partisanship
     */
    getPartisanship: function() {
      var partisanship = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return partisanship.partisanship;
    },

    /**
     * Get curiosity.
     *
     * @return     {Object}  Curiosity
     */
    getCuriosity: function() {
      var curiosity = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return curiosity.curiosity;
    },

    /**
     * Get Commitment.
     *
     * @return     {Object}  Commitment
     */
    getCommitment: function() {
      var commitment = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return commitment.commitment;
    },

    /**
     * Get sources diversity.
     *
     * @return     {Object}  Sources diversity
     */
    getSourcesDiversity: function() {
      var sourcesDiversity = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return sourcesDiversity.sources_diversity;
    },

    /**
     * Get sufficiency.
     *
     * @return     {Object}  Sufficiency
     */
    getSufficiency: function() {
      var sufficiency = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return sufficiency.sufficiency;
    },

    /**
     * Get rigor.
     *
     * @return     {Object}  Rigor
     */
    getRigor: function() {
      var rigor = this.totalGrades
        .find(tg => tg.group == this.groupId)
        .deliberations.find(u => u.deliberation == this.deliberation);
      return rigor.rigor;
    }
  }
};
</script>

<style lang="scss" scoped></style>
